// import { toast } from "react-toastify";
// import {
//     SeminarDto,
//     CreateSeminarDto,
//     UpdateSeminarDto
// } from "../Types/SeminarServiceTypes";

// import { apiDelete, apiPost, apiPublicGet, apiPut, apiRawDelete, apiRawPost } from "./apiClient";

// const GetSeminars = async (): Promise<SeminarDto[] | undefined> => {
//     try {
//         const res = await apiPublicGet("/seminar");
//         if (!res.ok) return undefined;
//         return await res.json();
//     } catch {
//         toast.error("Fel vid hämtning av seminarier");
//         return undefined;
//     }
// };

// const GetSeminarById = async (id: string): Promise<SeminarDto | undefined> => {
//     try {
//         const res = await apiPublicGet(`/seminar/${id}`);
//         if (!res.ok) return undefined;
//         return await res.json();
//     } catch {
//         toast.error("Fel vid hämtning av seminarium");
//         return undefined;
//     }
// };

// /* ======================
//    ADMIN – CREATE / UPDATE / DELETE
//    ====================== */

// const CreateSeminar = async (dto: CreateSeminarDto): Promise<SeminarDto | undefined> => {
//     try {
//         console.log(dto,'IN SEMINAR')
//         // const res = await apiPost(`/Seminar`, {
//         //     method: "POST",
//         //     body: JSON.stringify(dto)
//         // });
//         const res = await apiPost('/Seminar',dto);

//         const body = await res.json();
//         console.log(res,body)
//         if (res.status === 201) {
//             toast.success("Seminarium skapat");
//             return body;
//         }

//         toast.warning(JSON.stringify(body));
//         return undefined;
//     } catch {
//         toast.error("Tekniskt fel vid skapande av seminarium");
//         return undefined;
//     }
// };

// const UpdateSeminar = async (id: string, dto: UpdateSeminarDto): Promise<boolean> => {
//     try {
//         const res = await apiPut(`/seminar/${id}`, {
//             method: "PUT",
//             body: JSON.stringify(dto)
//         });

//         if (res.ok) {
//             toast.success("Uppdaterat");
//             return true;
//         }

//         toast.warning("Kunde inte uppdatera seminariet");
//         return false;
//     } catch {
//         toast.error("Fel vid uppdatering");
//         return false;
//     }
// };

// const DeleteSeminar = async (id: string): Promise<boolean> => {
//     try {
//         const res = await apiRawDelete(`/seminar/${id}`);

//         if (res.status === 204) {
//             toast.success("Seminarium borttaget");
//             return true;
//         }

//         toast.warning("Kunde inte ta bort seminariet");
//         return false;
//     } catch {
//         toast.error("Fel vid borttagning");
//         return false;
//     }
// };

// const SendSeminarInvites = async (id: string): Promise<boolean> => {
//     try {
//         const res = await apiPost(`/seminar/${id}/send-invites`, {
//             method: "POST"
//         });

//         const body = await res.json();

//         if (res.ok) {
//             toast.success("Inbjudningar skickade 🎉");
//             return true;
//         }

//         toast.warning(body.message || "Misslyckades");
//         return false;
//     } catch {
//         toast.error("Tekniskt fel vid utskick");
//         return false;
//     }
// };

// export const SeminarService = {
//     GetSeminars,
//     GetSeminarById,
//     CreateSeminar,
//     UpdateSeminar,
//     DeleteSeminar,
//     SendSeminarInvites
// };
import { toast } from "react-toastify";
import {
    SeminarDto,
    CreateSeminarDto,
    UpdateSeminarDto
} from "../Types/SeminarServiceTypes";

import { 
    apiDelete, 
    apiPost, 
    apiGet,
    apiPublicGet, 
    apiPut, 
    apiRawDelete, 
    apiRawPost, 
    apiRawPut
} from "./apiClient";


/* ======================
   PUBLIC
====================== */

const GetSeminars = async (): Promise<SeminarDto[] | undefined> => {
    try {
        return await apiPublicGet("/seminar");   // ✔ returns JSON directly
    } catch {
        toast.error("Fel vid hämtning av seminarier");
        return undefined;
    }
};

const GetSeminarById = async (id: string): Promise<SeminarDto | undefined> => {
    try {
        return await apiPublicGet(`/seminar/${id}`);  // ✔ returns JSON directly
    } catch {
        toast.error("Fel vid hämtning av seminarium");
        return undefined;
    }
};

const GetMySeminars = async (): Promise<SeminarDto[] | undefined> => {
    try {
        return await apiGet<SeminarDto[]>("/seminar/my-seminars");
    } catch {
        toast.error("Fel vid hämtning av dina seminarier");
        return undefined;
    }
};


/* ======================
   ADMIN – CREATE / UPDATE / DELETE
====================== */

const CreateSeminar = async (dto: CreateSeminarDto): Promise<SeminarDto | undefined> => {
    try {
        const res = await apiRawPost(`/seminar`, dto);
        const body = await res.json();

        if (res.status === 201) {
            toast.success("Seminarium skapat");
            return body;
        }

        toast.warning(JSON.stringify(body));
        return undefined;

    } catch {
        toast.error("Tekniskt fel vid skapande av seminarium");
        return undefined;
    }
};

// const UpdateSeminar = async (id: string, dto: UpdateSeminarDto): Promise<boolean> => {
//     try {
//         const res = await apiRawPut(`/seminar/${id}`, dto);

//         if (res.ok) {
//             toast.success("Uppdaterat");
//             return true;
//         }

//         toast.warning("Kunde inte uppdatera seminariet");
//         return false;

//     } catch {
//         toast.error("Fel vid uppdatering");
//         return false;
//     }
// };
const UpdateSeminar = async (id: string, dto: UpdateSeminarDto): Promise<SeminarDto | undefined> => {
    try {
        const res = await apiRawPut(`/seminar/${id}`, dto);
        const body = await res.json();

        if (res.ok) {
            toast.success("Uppdaterat");
            return body; // <-- return SeminarDto
        }

        toast.warning("Kunde inte uppdatera seminariet");
        return undefined;

    } catch {
        toast.error("Fel vid uppdatering");
        return undefined;
    }
};
const DeleteSeminar = async (id: string): Promise<boolean> => {
    try {
        const res = await apiRawDelete(`/seminar/${id}`);

        if (res.status === 204) {
            toast.success("Seminarium borttaget");
            return true;
        }

        toast.warning("Kunde inte ta bort seminariet");
        return false;

    } catch {
        toast.error("Fel vid borttagning");
        return false;
    }
};

const SendSeminarInvites = async (id: string): Promise<boolean> => {
    try {
        const res = await apiRawPost(`/seminar/${id}/send-invites`);

        if (res.ok) {
            toast.success("Inbjudningar skickade 🎉");
            return true;
        }

        const body = await res.json();
        toast.warning(body.message || "Misslyckades");
        return false;

    } catch {
        toast.error("Tekniskt fel vid utskick");
        return false;
    }
};


export const SeminarService = {
    GetSeminars,
    GetSeminarById,
    GetMySeminars,
    CreateSeminar,
    UpdateSeminar,
    DeleteSeminar,
    SendSeminarInvites
};

